import { StyledPartitionCard } from '@/components/styles';
import addSoftHyphenation from '@/lib/addSoftHyphenation';
import { ActiveLink, Picture } from '@/components';

export default function PartitionCard({ image: imageFromProps, imageT, title, desc, text, link: { href, as }, ...props }) {
  const image = imageFromProps || {};

  return (
    <StyledPartitionCard {...props} cardImage={Object.keys(image).length > 0 ? undefined : 'none'}>
      <StyledPartitionCard.Bg isMobile={imageT}>{Object.keys(image).length > 0 && <Picture {...image} />}</StyledPartitionCard.Bg>
      {imageT && <StyledPartitionCard.Bg mobile>{Object.keys(imageT).length > 0 && <Picture {...imageT} />}</StyledPartitionCard.Bg>}
      {(href || as) && (
        <StyledPartitionCard.Arrow>
          <svg fill="currentColor" width="16" height="10" viewBox="0 0 16 10" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 4.00015L5 4.00015L5 -4.80825e-07L-2.18557e-07 5L5 10L5 6.00015L16 6.00015L16 4.00015Z"></path>
          </svg>
        </StyledPartitionCard.Arrow>
      )}
      <StyledPartitionCard.Content>
        <StyledPartitionCard.Title>{addSoftHyphenation(title, 15)}</StyledPartitionCard.Title>
        {desc && <StyledPartitionCard.Desc>{desc}</StyledPartitionCard.Desc>}
        {text && <StyledPartitionCard.Text>{text}</StyledPartitionCard.Text>}
      </StyledPartitionCard.Content>
      {(href || as) && (
        <ActiveLink href={href} as={as}>
          <StyledPartitionCard.Link />
        </ActiveLink>
      )}
    </StyledPartitionCard>
  );
}
